export default function () {
    const burgerElement = document.querySelector('#burger-input');

    if (burgerElement) {
        burgerElement.addEventListener('change', e => {
            window.scrollTo(0, 0);
            document.documentElement.classList.toggle('nooverflow', e.currentTarget.checked);
        });
    }

    const backdropElement = document.querySelector('#header-navigation-backdrop');
    if (backdropElement) {
        backdropElement.addEventListener('click', e => {
            burgerMenuToggle(burgerElement);
        });
    }
}

export function burgerMenuToggle (burgerElement) {
    burgerElement.checked = !burgerElement.checked;
    document.documentElement.classList.toggle('nooverflow', burgerElement.checked);
}

export function burgerMenuClose (burgerElement) {
    burgerElement.checked = false;
    document.documentElement.classList.remove('nooverflow');
}
